/**
 * Responsive breakpoints — fed to Unistyles' StyleSheet.configure.
 *
 * `md = 800` matches the legacy `IS_BIG = width > 800` heuristic in
 * src/common/utils/mobileUtils.js (DimensionsContext). Keeping the same threshold
 * avoids layout discontinuities for screens migrated to Unistyles.
 */
export const breakpoints = {
    xs: 0,
    sm: 480,
    md: 800,
    lg: 1200,
    xl: 1600,
} as const

export type Breakpoint = keyof typeof breakpoints
